import moment from 'moment'
import { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'

import useCallApi from '../../../hooks/useCallApi'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import callAPI from '../../../helpers/callAPI'
import useDateRangeFilter from '../../../hooks/useDateRangeFilter'
import DateRangeFilter from '../../Reports/Filters/DateRangeFilter/DateRangeFilter'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import useQueryParams from '../../../hooks/useQueryParams'
import AffiliateDetailMatchingInformation from '../affiliateDetailMatchingInformation/AffiliateDetailMatchingInformation'

const AffiliateMatchingInformationList = () => {
    document.title = 'Affiliate Matching Information List'
    
    const [confirmDelete, setConfirmDelete] = useState(null) // Store matched_key and matched_value

    const { data, dataLoaded, refetch } = useCallApi(`compliance/affiliateMatchingInformation/list`, 'GET', {}, [])

    const deleteWhitelistItem = async (matched_key, matched_value) => {
        const result = await callAPI(`compliance/affiliateMatchingInformation/list`, 'DELETE', {
            matched_key: matched_key,
            matched_value: matched_value
        }, false)
        
        if (result && result.success) {
            refetch()
            setConfirmDelete(null)
        }
    }

    const getReportOutput = () => {

        let columns = [
            {
                Header: 'Key',
                accessor: 'matched_key',
            },
            {
                Header: 'Value',
                accessor: 'matched_value',
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: (tableData) => {
                    const item = tableData.row.original
                    const isConfirming = confirmDelete?.matched_key === item.matched_key && 
                                        confirmDelete?.matched_value === item.matched_value
                    
                    return (
                        <>
                            {isConfirming ? (
                                <button 
                                    className="btn btn-sm btn-danger" 
                                    onClick={() => deleteWhitelistItem(item.matched_key, item.matched_value)}
                                >
                                    Confirm Delete
                                </button>
                            ) : (
                                <button 
                                    className="btn btn-sm btn-outline-danger" 
                                    onClick={() => setConfirmDelete({ matched_key: item.matched_key, matched_value: item.matched_value })}
                                >
                                    Delete
                                </button>
                            )}
                        </>
                    )
                }
            }
        ]
       

        return (
            <ReportTable
                data={data.whitelist}
                columns={columns}

            />
        )
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Affiliate Matching Information</h1>

            </div>
            <div className="row">
                <div className="col-12">
                    <Card>
                        <Card.Header className="d-flex align-items-center">
                            <h5 className="mb-h1-dark mr-2">Affiliate Matching Information</h5>
                           
                        </Card.Header>
                        <Card.Body className="p-0">
                            {dataLoaded ? (
                                data.success ? (
                                    getReportOutput()
                                ) : (
                                    <div className="alert alert-danger" role="alert">
                                        {data.message}
                                    </div>
                                )
                            ) : (
                                <Loading />
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>


        </div>
    )
}

export default AffiliateMatchingInformationList
